import './DesignSecond.css'; 
let DesignSecond = (props)=> {

    let designsecondarraydata = {
        Streamacd : props.AcademicData,
        Streamcomp : props.ComputerData,
        Streamtec : props.TechDataexp,
        workexperienceYear : props.ExperienceData,
        PassPortNumber : props.sendpassportdata,
        HeIght : props.sendphysicaldata, 
  
 
    };
     

    let checkemptyvaluesofinput = ()=>{
        let academichideelm = document.querySelector(".acadhideelm");
        let computerhideelm = document.querySelector(".comphideelm");
        let techhideelm = document.querySelector(".techloop_cont");
        let woekexpparent = document.querySelector(".Experiance_cont"); 
        let passportdatacont = document.querySelector('.dessecpassportdet');
        let physicaldatacont = document.querySelector('.dessecphysicaldet');


        if(designsecondarraydata.Streamacd == ""){
            academichideelm.style.display = "none";
        }else{
            // props.AcademicDatas.splice(props.AcademicDatas.length - 1, 1);
        }
        if(designsecondarraydata.Streamcomp == ""){  
            computerhideelm.style.display = "none";

        }else{
            // props.ComputerDatas.splice(props.ComputerDatas.length - 1, 1);
        }
        if(designsecondarraydata.Streamtec == ""){
            techhideelm.style.display = "none";
        }else{
            // props.TechDataexps.splice(props.TechDataexps.length - 1, 1);
        }
        if(designsecondarraydata.workexperienceYear == ""){
            woekexpparent.style.display = "none";
        }
        if(designsecondarraydata.PassPortNumber == ""){
            passportdatacont.style.display = "none"; 
        }
        if(designsecondarraydata.HeIght == ""){
            physicaldatacont.style.display = "none";
        }
    }

    setTimeout(() => {
         checkemptyvaluesofinput();   
    }, 100);
    let printfunction=()=>{ 
        window.print();
        
    }
   
    return(
  
            <div className='secdes_main_cont'>
            <div className='left_side_cont'>
                <div className='education_cont'> 
                    <table className='comp_table_cont acadhideelm'>
                        <caption className='heading_h2'>Academic Qualification</caption>
                        <thead>
                        <tr>
                                <td className='comploop_td'>Stream</td>
                                <td className='comploop_td'>Board/Univercity</td>
                                <td className='comploop_td'>Passing Year</td>
                                <td className='comploop_td'>%Age</td>
                        </tr>
                        </thead>
                        <tbody className='tbody_cont'>
                
                
            
                        {  
                            props.AcademicData.map(
                                AcAData =>(
                                    <tr>
                                    <td className='acad_td_loop'>{AcAData.ExamName}</td>
                                    <td className='acad_td_loop'>{AcAData.BoardName}</td>
                                    <td className='acad_td_loop'>{AcAData.PassingYear}</td>
                                    <td className='acad_td_loop'>{AcAData.PercentAge}</td>
                                    
                                </tr>
                                )
                            )
                        }
                        </tbody>
                        
                    </table>
                    <table className='comp_table_cont comphideelm'>
                            <caption className='heading_h2'>Computer Qualification</caption>
                            <thead>
                                    <tr>
                                        <td className='comploop_td'>Course</td>
                                        <td className='comploop_td'>Board/Univercity</td>
                                        <td className='comploop_td'>Passing Year</td>
                                        <td className='comploop_td'>%Age</td>
                                    </tr>
                            </thead>
                            <tbody className='tbody_cont'>
                                { 
                                    props.ComputerData.map(
                                        CompData => (
                                            <tr>
                                                <td className='acad_td_loop'>{CompData.CourseName}</td>
                                                <td className='acad_td_loop'>{CompData.Frompass}</td>
                                                <td className='acad_td_loop'>{CompData.Compassingy}</td>
                                                <td className='acad_td_loop'>{CompData.compercent}</td>
                                                
                                            </tr>
                                
                                        )
                                    )
                                }
                            </tbody>
                            
                    </table>
                    <table className='techloop_cont'>
                        <caption className='heading_h2'>Technical Qualification</caption>
                            <thead>
                                <tr>
                                    <td className='tech_loop_td'>Course</td>
                                    <td className='tech_loop_td'>Trade Name</td>
                                    <td className='tech_loop_td'>passing year</td>  
                                    <td className='tech_loop_td'>percentage</td>
                                </tr>
                    
                            </thead> 
                            {
                                props.TechDataexp.map(
                                    techdataaa =>(
                                        <tbody>
                                                <tr>
                                                <td className='tech_loop_td'>{techdataaa.TechCourseName}</td>
                                                <td className='tech_loop_td'>{techdataaa.TechTradeName}</td>
                                                <td className='tech_loop_td'>{techdataaa.TechPassingYear}</td>
                                                <td className='tech_loop_td'>{techdataaa.TechPercentage}</td>
                                            </tr>
                                            <tr className='sub_tr2'>
                                                <td colSpan='4'>  {techdataaa.Techfromwhere}</td>
                                            </tr>
                                    </tbody>
                                    )
                                )
                            }
                    </table> 
                    <table className='dessecpassportdet'>
                <caption className='dessecpasspcaption'>Passport Details</caption>
                    <tbody>
                        <tr>
                            <td>Name</td>
                            <td>{props.UsersPersonlD.Name}</td>
                        </tr>
                        <tr>
                            <td>Passport Number</td>
                            <td>{props.sendpassportdata.paassportnumber}</td>
                        </tr>
                        <tr>
                            <td>Issuing Date</td>
                            <td>{props.sendpassportdata.passportissuingdate}</td>
                        </tr>
                        <tr>
                            <td>Expiry Date</td>
                            <td>{props.sendpassportdata.passportexpirydate}</td>
                        </tr>
                        <tr>
                            <td>District</td>
                            <td>{props.sendpassportdata.passportdistrict}</td>
                        </tr>
                    </tbody>
                    </table>
                    <table className='dessecphysicaldet'>
                        
                        <caption className='dessecphycaption'>Physical Details</caption>
                        <tbody>
                            <tr>
                                <td>Height</td>  
                                <td>Weight</td>
                                <td>Blood Group</td>
                                <td>PwP Disability</td>
                            </tr>
                            <tr>
                                <td>{props.sendphysicaldata.Height}</td>
                                <td>{props.sendphysicaldata.weight}</td>
                                <td>{props.sendphysicaldata.BloodGroup}</td>  
                                <td>{props.sendphysicaldata.Pwpdisability}</td> 
                            </tr>
                        
                        
                        </tbody>
                    </table>
                </div>
                <div className='education_cont Experiance_cont'>
                    <h2 className='heading_h2 exp_heading'>Work Experiences</h2>
                    <ul>
                
                        {  
                            props.ExperienceData.map(
                                ExpdataToExpComp =>( 
                                    <li className='loop_li_of_exp'>
                                        <span>{ExpdataToExpComp.ExperianceYear} </span>
                                        {ExpdataToExpComp.Year} 
                                        <span> {ExpdataToExpComp.CompanyName} </span> 
                                        {ExpdataToExpComp.At} 
                                        <span> {ExpdataToExpComp.CompanyAddress} </span> 
                                        {ExpdataToExpComp.From} 
                                        <span> {ExpdataToExpComp.FromDateToDate } </span>
                                    </li>
                                )
                            )
                        }
                        
                        
                    </ul>
                </div> 
            </div>
            <div  className='right_side_cont'>  
            <div className='printbtn' style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                    <button style={{padding: "10px 20px", backgroundColor: "lightblue", border: "none", color: "black", borderRadius: "5px",  fontSize: "22px"}} onClick={printfunction}>Print</button>
            </div>
                <div className='carrierdata'> 
                    <p style={{color: "white"}}>{props.UsersPersonlD.cardata}{props.carrierdataf}</p>  
                </div>
                <div className='contact_container'> 
                    <h2 className='contace_heading'>Contact Me</h2>
                    <div className='mobnum_cont contact_same_styling'> 
                        <span><i class='bx bxs-phone'></i></span>
                        <span>{props.UsersPersonlD.mobnum}{props.Userdata.MobileNum}</span>  
                    </div>
                    <div className='Emailid_cont contact_same_styling'>  
                        <span><i class='bx bx-envelope' ></i></span>
                        <span>{props.UsersPersonlD.Email_ID}{props.Userdata.Email}</span>
                    </div>
                    <div className='Alternatenum_cont contact_same_styling'>
                        <span><i class='bx bx-mobile'></i></span>                
                        <span>{props.UsersPersonlD.Alternate}{props.Userdata.Altnum}</span>
                    </div>
                </div>
                <div className='address_cont'>
                    <h2 className='address_heading'><i class='bx bx-map' ></i>Address</h2>
                    <div className='address_subcont1'>
                        <span><i class='bx bxs-hand-right'></i></span>
                        <div>
                            <span>House Number:-</span><span>{props.UsersPersonlD.hnum}{props.Userdata.Hnum}</span> 
                        </div>   
                    </div>
                    <div className='address_subcont1'>
                        <span><i class='bx bxs-hand-right'></i></span>
                        <div>
                            <span>Vill:-</span><span>{props.UsersPersonlD.Village}{props.Userdata.Vill}</span> 
                        </div>   
                    </div>
                    <div className='address_subcont1'>                     
                        <span><i class='bx bxs-hand-right'></i></span>
                        <div>
                            <span>Post:-</span><span>{props.UsersPersonlD.Post_Office}{props.Userdata.post}</span>
                        </div>           
                    </div>
                    <div className='address_subcont1'>
                        <span><i class='bx bxs-hand-right'></i></span>
                        <div>
                            <span>District:-</span><span>{props.UsersPersonlD.District}{props.Userdata.city}</span>
                        </div>   
                    </div>
                    <div className='address_subcont1'>
                        <span><i class='bx bxs-hand-right'></i></span>
                        <div>
                            <span>Thana:-</span><span>{props.UsersPersonlD.Thana}{props.Userdata.police}</span>
                        </div>   
                    </div>
                    <div className='address_subcont1'>
                        <span><i class='bx bxs-hand-right'></i></span>
                        <div>
                            <span>State:-</span><span>{props.UsersPersonlD.State}{props.Userdata.state}</span>
                        </div>   
                    </div>
                    <div className='address_subcont1'>
                        <span><i class='bx bxs-hand-right'></i></span>
                        <div>
                            <span>Pin Code:-</span><span>{props.UsersPersonlD.Pin_Code}{props.Userdata.pincode}</span>
                        </div>   
                    </div>
                </div>
                <div className='personaldetails_cont'>
                    <table className='destwotable'>
                        <caption className='perinfo_caption'>Personal Info</caption>
                        <tbody>
                            <tr>
                                <td>Name</td>
                                <td>{props.UsersPersonlD.Name}{props.Userdata.applicantname}</td>
                            </tr>
                            <tr>
                                <td>Father's Name</td>
                                <td>{props.UsersPersonlD.fname}{props.Userdata.fathername}</td>  
                            </tr>
                            <tr>
                                <td>Mother's Name</td>
                                <td>{props.UsersPersonlD.Mname}{props.Userdata.mothername}</td>
                            </tr>
                            <tr>
                                <td>DOB</td>
                                <td>{props.UsersPersonlD.dob}{props.Userdata.date}</td>
                            </tr>
                            <tr>
                                <td>Nationality</td>
                                <td>{props.UsersPersonlD.Nationality}{props.Userdata.nationality}</td>
                            </tr>
                            <tr>
                                <td>Religion</td>
                                <td>{props.UsersPersonlD.Religion}{props.Userdata.religion}</td>
                            </tr>
                            <tr>
                                <td>Marrital Status</td>
                                <td>{props.UsersPersonlD.Marital_Status}{props.Userdata.maritalstatus}</td>
                            </tr>
                            <tr>
                                <td>Hobbies</td>
                                <td>{props.UsersPersonlD.Hobbies}{props.Userdata.hobbies}</td>
                            </tr>
                            <tr>
                                <td>Language</td>
                                <td>{props.UsersPersonlD.Languages}{props.Userdata.language}</td>
                            </tr>
                        
                        </tbody>
                    </table>
                </div>

            </div>
            
        
        
            <div className='absolute_div heading_pic_cont'>
                <div className='img_cont'>
                    {
                        props.imagedataexp === "" ?  <img alt='' className='Desecond_img onee' src={props.UsersPersonlD.Imagge}/> : <img alt='' className='Desecond_img twoo' src={props.imagedataexp}/>
                    }
                    
                </div>
                <div className='name_cont'>
                    <div className='nameand_prof_cont'><span>{props.UsersPersonlD.Name}{props.Userdata.applicantname}</span></div>
                    <span></span>
                </div>
            </div>
        
            </div>
            
        
    );
}
export default DesignSecond;  